/* readonly */
import { ClippingConfig, NoiseFloorConfig } from '@/types/composables';

export const BUFFER_SIZE: Readonly<number> = 5600;
export const SAMPLE_RATE: Readonly<number> = 16000;
export const VOLUME_RATIO: Readonly<number> = 0.2;

export const MIC_MIN_RADIUS: Readonly<number> = 0.5; // 최소 반지름
export const MIC_MAX_RADIUS: Readonly<number> = 2; // 최대 반지름

export const MIC_INITIAL_GAIN = 15;
export const MIC_MAGNIFICATION_GAIN = 1;

export const MIC_ADVANCED_OPTIONS = {
  upperThreshold: -25.0,
  lowerThresholdLead: -45.0,
  lowerThresholdTail: -45.0,
  vadThreshold: -25.0,
};

export const SILENCE_GAIN_THRESHOLD = 0.05; // 최소 음성 게인
export const NOISE_FLOOR_THRESHOLD = 5000; // 노이즈 플로어 판정 시간 (ms)
export const CLIPPING_THRESHOLD = 5000; // 클리핑 판정 시간 (ms)

export const MIN_PITCH = 80;
export const MAX_PITCH = 400;
export const THRESHOLD_PITCH = 0.5;

export const DEFAULT_NOISE_FLOOR_CONFIG: NoiseFloorConfig = {
  minDecibels: -45,
  maxDecibels: -29,
} as const;
export const DEFAULT_CLIPPING_CONFIG: ClippingConfig = {
  threshold: 0.01,
  density: 0.2,
} as const;

export const INITIAL_HINT_BOX_COOLDOWN = 10000 as const;
export const MAX_SAMPLE_GAIN_COUNT = 10 as const;
